import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
  selector: '[uClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  @Output() readonly uClickOutside = new EventEmitter<any>();

  constructor(private _elementRef: ElementRef) {}

  @HostListener('document:click', ['$event', '$event.target'])
  @HostListener('document:touchstart', ['$event', '$event.target'])
  // @HostListener('document:mouseover', ['$event', '$event.target'])
  public onClick($event, targetElement) {
    const isClickedInside = this._elementRef.nativeElement.contains(targetElement);
    if (!isClickedInside) {
      this.uClickOutside.emit($event);
    }
  }
}
